import Configurator from "../components/Configurator";
import { HERO_IMG } from "../lib/constants";

export default function Product() {
  return (
    <div data-testid="product-page">
      <section
        className="relative h-[55vh] min-h-[400px] bg-cover crop-watermark-wide"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(3,26,32,0.4), rgba(3,26,32,0.85)), url(${HERO_IMG})`,
        }}
      >
        <div className="absolute inset-0 max-w-7xl mx-auto px-6 sm:px-8 flex flex-col justify-end pb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-6">
            <span className="gold-rule" />A termék
          </div>
          <h1 className="font-serif text-5xl sm:text-7xl text-white leading-[1.05] font-light">
            SolarSimple Pergola
          </h1>
          <p className="text-base sm:text-lg text-white/85 mt-4 max-w-xl">
            Egy időtálló alumínium architektúra, amelyet az Ön elképzelése
            szerint hangolunk – pontról pontra, 3D-ben.
          </p>
        </div>
      </section>
      <Configurator />
    </div>
  );
}
